import Vue from 'vue';
import Vuex from 'vuex';
// import createPlugin from 'logrocket-vuex';
// import LogRocket from '../logrocket';
import createCompanyModule from './modules/company';
import createVacancyModule from './modules/vacancy';
import createCandidateModule from './modules/candidate';
import createCandidatePageModule from './modules/candidatePage';
import createInterviewModule from './modules/interview';
import createCountryModule from './modules/country';
import createVacanciesListModule from './modules/vacanciesList';
import createCommunicationModule from './modules/communication';


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    company: createCompanyModule(),
    vacancy: createVacancyModule(),
    candidate: createCandidateModule(),
    candidatePage: createCandidatePageModule(),
    interview: createInterviewModule(),
    country: createCountryModule(),
    vacanciesList: createVacanciesListModule(),
    communication: createCommunicationModule(),
  },
  strict: process.env.NODE_ENV !== 'production',
  // plugins: [createPlugin(LogRocket)],
});
